import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';
import axios from 'axios';
import { useFormik } from 'formik';
import * as yup from 'yup';
import "./SignOut.scss";
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { getUrl, useDomainNavigate, domain } from '../../domain';
import { UrlHelpers } from '../../lib/Helpers';

export default function ForgotPassword() {
    const [openConfirmation, setOpenConfirmation] = React.useState(false);
    const navigate = useDomainNavigate();
    const params = new URLSearchParams(window.location.search);
    let returnUrlParam = UrlHelpers.getSafeUrl(params.get('ReturnUrl'));

    const handleCloseConfirmation = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }

      setOpenConfirmation(false);
    };

    const axiosconfig = {
        headers: {
            "Content-Type": "application/json",
            "SubDomain": domain.subDomain
        },
    };

    const initialValues = { email: '' };
    const validationSchema = yup.object({
        email: yup
            .string('Enter your email')
            .email('Enter a valid email')
            .required('Email is required'),
    });

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const returnUrlEncoded = encodeURIComponent(returnUrlParam);
            axios.post(getUrl(`/identity/account/forgotPassword?ReturnUrl=${returnUrlEncoded}`), values.email, axiosconfig) // forgotpassword endpoint
                .then(response => { // response contains user Object
                    formik.setSubmitting(false);

                    if (response.status === 200) {
                        setOpenConfirmation(true);
                    }
                })
                .catch(error => {
                    formik.setSubmitting(false);
                });
        },
    });

    return (
        <>
            <AppBar position="fixed"  elevation={0}>
                <Toolbar sx={{ pl: 0, background: 'white', minHeight:'30px' }} variant="dense">
                    <Box
                        sx={{
                            flexGrow: 1,
                            alignItems: 'center',
                            display: { xs: 'flex' },
                        }}
                    >
                        <Button onClick={() => navigate(-1)} variant="none" >
                            <ChevronLeftIcon sx={{ color: 'black', mr:'100px', mt:'8px', mb:'5px' }} />
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>
            <Box
                sx={{
                    marginTop: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography variant="subtitle1" gutterBottom component="div" sx={{mt:2}}>
                    Enter your email to reset your password.
                </Typography>
                <form onSubmit={formik.handleSubmit}
                >
                    <TextField sx={{ mt: 2 }}
                        type="email"
                        name="email"
                        label="Email Address"
                        fullWidth
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={formik.isSubmitting}
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Reset Password
                    </Button>
                </form>

            </Box>
            <Snackbar
                open={openConfirmation}
                autoHideDuration={6000}
                onClose={handleCloseConfirmation}
            >
                <Alert severity="success">
                    <AlertTitle>Email Sent</AlertTitle>
                        Please check your email to reset your password.
                </Alert>
            </Snackbar>
        </>
    );
}